import React from "react";
import {
  Button,
  Col,
  Descriptions,
  List,
  Row,
  Space,
  Tooltip,
  Typography,
  Badge
} from "antd";
import { TCaseLawDocumentPresentationModel } from "../../presenter/model/CaseLawDocumentPresentationModel";

import Link from "../../../core/ui/components/Link";
import { FileWordOutlined } from "@ant-design/icons";

export interface CaseLawDocumentListItemProps {
  translate: any;
  item: TCaseLawDocumentPresentationModel;
  showCaseLawDocumentDetails: any;
}
const CaseLawDocumentListItem: React.FC<CaseLawDocumentListItemProps> = (
  props: CaseLawDocumentListItemProps
) => {
  const { translate, item, showCaseLawDocumentDetails } = props;
  return (
    <List.Item style={{ cursor: "pointer" }} className={"card-list-item"}>
      <Row className={"card-list-item-actions-top"}>
        <Col
          xs={24}
          sm={24}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Badge
            count={translate(
              `editors.case_law_documents.status_values.${item.status}`
            )}
            className={"png-badge"}
          />
        </Col>
      </Row>
      <Link
        block
        type="text"
        onClick={() => showCaseLawDocumentDetails(item.id)}
        children={
          <Col>
            <Typography.Paragraph ellipsis={{ rows: 3 }} strong>
              {item.summaryTranslation ?? item.summary}
            </Typography.Paragraph>
          </Col>
        }
      />
      <Row className={"card-list-item-decriptions"}>
        <Col>
          <Descriptions size={"small"}>
            <Descriptions.Item
              style={{ width: "40%" }}
              label={
                <strong>
                  {translate("editors.case_law_documents.organisation_name")}
                </strong>
              }
            >
              {item.organisationName}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ width: "40%" }}
              label={
                <strong>
                  {translate(
                    "editors.case_law_documents.case_law_document_type"
                  )}
                </strong>
              }
            >
              {item.caseLawDocumentType?.name}
            </Descriptions.Item>
            <Descriptions.Item
              style={{ width: "20%" }}
              label={
                <strong>{translate("editors.case_law_documents.date")}</strong>
              }
            >
              {item.formattedDate}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row
        className={"card-list-item-actions-bottom"}
        style={{ display: "none" }}
      >
        <Col>
          <Space size={"small"}>
            <Tooltip title="Preuzmite dokument">
              <Button type="link" icon={<FileWordOutlined />} shape="circle">
                Preuzmite dokument
              </Button>
            </Tooltip>
          </Space>
        </Col>
      </Row>
    </List.Item>
  );
};
export default CaseLawDocumentListItem;
